// AI-CONTEXT: See docs/features/planner-overzicht-bkb.md
// De ster: één vlag voor 'extra aandacht nodig', gedeeld door huishoudens
// (`Adresses.Starred`) en deelnemers (`Personas.Starred`). Verzoek
// BuurtKlusBedrijf 2026-10-06. Geen status en geen label: een status is de
// trechter, een label is per organisatie in te richten; de ster is overal
// hetzelfde en daarom ook op het dashboard bij elkaar te zetten.

/**
 * @param {{Starred?: *}} [doc]
 * @returns {boolean} Strikt `=== true`, zoals de andere vlaggen; tekst of ontbrekend is 'geen ster'
 */
const isStarred = (doc) => doc?.Starred === true

/**
 * De velden die een wissel van de ster wegschrijft: de vlag, wie en wanneer.
 * @param {boolean} next - De nieuwe stand
 * @param {string} [authId] - Wie de ster zet of weghaalt
 * @param {*} timestamp - `timestamp` uit firebase/config (serverTimestamp)
 * @returns {{Starred: boolean, StarredBy: string, StarredAt: *}}
 */
const starredPatch = (next, authId, timestamp) => ({
    Starred: next === true,
    StarredBy: authId || 'unknown',
    StarredAt: timestamp,
})

/**
 * @param {Array<object>} [items]
 * @returns {Array<object>} Alleen de rijen met een ster, in de aangeleverde volgorde
 */
const filterStarred = (items) => (Array.isArray(items) ? items : []).filter(isStarred)

export { isStarred, starredPatch, filterStarred }
